import { useRef, useState } from "react";
import { UploadCloud, Sparkles, FileSpreadsheet } from "lucide-react";
import { Button } from "./ui/button";

export const UploadZone = ({ onFile, onDemo, replacing }) => {
  const input = useRef(null);
  const [drag, setDrag] = useState(false);
  const handle = (f) => f && onFile(f);
  return (
    <div className="max-w-5xl mx-auto px-6 pt-12 pb-16 fade-up">
      <p className="label-mono mb-4">Data management</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-100 max-w-3xl">
        {replacing ? "Upload a new CSV to replace it." : "Drop a CSV. See every user, every month."}
      </h1>
      <p className="mt-5 text-slate-400 max-w-xl text-sm sm:text-base">
        The file is parsed in your browser in streaming chunks, then only the monthly per-user summary is saved, so the dashboard opens instantly every visit. Uploading replaces the current dataset.
      </p>
      <div
        data-testid="upload-csv-dropzone"
        onClick={() => input.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files?.[0]); }}
        className={`mt-12 cursor-pointer rounded-xl border border-dashed p-12 sm:p-16 transition-colors duration-200 ${drag ? "border-ep bg-ep/5" : "border-slate-700 bg-[#111827] hover:border-slate-500"}`}
      >
        <div className="flex flex-col sm:flex-row sm:items-center gap-6">
          <div className="h-14 w-14 rounded-lg bg-ep/10 border border-ep/30 flex items-center justify-center">
            <UploadCloud className="h-7 w-7 text-ep-soft" />
          </div>
          <div className="flex-1">
            <p className="text-slate-100 font-medium text-lg">Drag & drop your CSV here</p>
            <p className="text-slate-500 text-sm mt-1">or click to browse — tested with 2M+ rows</p>
          </div>
          <FileSpreadsheet className="hidden sm:block h-10 w-10 text-slate-700" />
        </div>
        <input ref={input} type="file" accept=".csv,text/csv" className="hidden" data-testid="upload-csv-input" onChange={(e) => handle(e.target.files?.[0])} />
      </div>
      <div className="mt-6 flex items-center gap-4">
        <Button variant="outline" data-testid="upload-demo-data-button" onClick={onDemo} className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white">
          <Sparkles className="h-4 w-4 mr-2 text-amber-400" /> Try demo dataset (250k rows)
        </Button>
        <span className="text-xs text-slate-500">Needs columns for user, date and (optionally) quantity.</span>
      </div>
    </div>
  );
};
